<template>
  <f7-page>
    <div class="mx-auto w-11/12 sm:w-7/12 sm:min-w-150 mt-2 sm:mt-12 max-w-4xl">
      <div class="sm:flex items-center">
        <img
          class="block mx-auto sm:mx-0 h-48"
          src="@/assets/rest-api.svg"
          alt="Automatizaciones"
        >
        <div class="text-center self-center sm:ml-2 text-2xl sm:text-4xl font-bold sm:text-left">
          Configuración API
        </div>
        <svg
          v-if="saving"
          class="animate-spin ml-4 h-5 w-5 text-purple-500"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            class="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            stroke-width="4"
          />
          <path
            class="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          />
        </svg>
      </div>
      <div
        v-if="totalCredits > 0"
        class="p-4 my-4 bg-gray-200 rounded-md"
      >
        <div class="text-lg">
          Creditos Totales: <span class="text-green-500 font-bold text-xl">{{ totalCredits }}</span>
        </div>
        <div class="text-lg">
          Creditos usados: <span class="text-blue-500 font-bold text-xl">{{ consumedCredits }}</span>
        </div>
        <div
          class="flex justify-center w-full mt-4"
        >
          <div
            :style="`width: ${consumedPercentage}%`"
            class="flex flex-col text-center text-xs text-blue-500"
          >
            <div
              class="h-2 bg-blue-500"
            />
            <div>
              {{ consumedPercentage }}%
            </div>
          </div>
          <div
            class="h-2 bg-gray-100"
            :style="`width: ${100 - consumedPercentage}%`"
          />
        </div>
      </div>
      <div class="p-4 my-4 bg-gray-200 rounded-md">
        <div class="text-lg">
          API Token:
        </div>
        <div class="flex justify-between p-2 mt-2 text-purple-500 bg-purple-100 border-purple-500 border rounded-sm text-lg">
          <input
            ref="tokenContainer"
            class="w-full bg-purple-100 mr-6 truncate"
            readonly
            :value="actualToken || 'Sin Token, por favor genera uno'"
          >
          <a
            class="border border-purple-500 border-opacity-0 hover:border-opacity-100 rounded-sm"
            @click="toClipboard"
          >
            <transition name="fade">
              <div
                v-if="copied"
                class="absolute -ml-10 -mt-12 p-2 bg-gray-500 text-green-500 rounded-md"
              >Copiado</div>
            </transition>
            <eva-icon
              class="align-middle"
              name="copy-outline"
              fill="#6C63FF"
            />
          </a>
        </div>
        <div class="sm:flex justify-between items-center mt-2">
          <a
            :class="`text-white bg-purple-500 ${saving ? 'opacity-50 cursor-default' : '' } flex px-4 py-2 rounded-md items-center text-md sm:w-1/3`"
            @click="generateToken"
          >
            <div
              class="block-inline text-center w-full"
            >
              Crear uno nuevo
            </div>
          </a>
          <div class="p-2 text-purple-500 rounded-md">
            Fecha: {{ tokenTime }}
          </div>
        </div>
      </div>
      <div class="p-4 my-4 bg-gray-200 rounded-md">
        <tag-manager
          :disabled="saving"
          :success="success"
          :currentTags="currentIPs"
          :rules="{ regex: /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/ }"
          creator
          @tag:add="addIP"
          @tag:remove="removeIP"
        >
          <div class="text-lg">
            IPs permitidas:
          </div>
        </tag-manager>
      </div>
    </div>
  </f7-page>
</template>

<script>
import tagManager from '../components/tagManager'
import { mapState } from 'vuex'
import { firebaseDb } from '../utils/firebase'
import * as axios from 'axios'
import moment from 'moment-timezone'
export default {
  components: {
    tagManager,
  },
  data () {
    return {
      saving: false,
      success: null,
      creditBinding: null,
      copiedTimmer: null,
      copied: false,
      consumedCredits: 0,
    }
  },
  computed: {
    totalCredits () {
      if (this.instancesInfo[this.instanceID].settings) {
        return this.instancesInfo[this.instanceID].settings.api.totalCredits
      }
      return 0
    },
    consumedPercentage () {
      const percentage = (this.consumedCredits) / (this.totalCredits || 1) * 100
      return Math.round((percentage + Number.EPSILON) * 100) / 100
    },
    tokenTime () {
      if (this.actualToken.length > 0) {
        const time = this.instancesInfo[this.instanceID].settings.api.apiToken.timestamp.toDate()
        return moment(time).format('D/M/YY - HH:mm:ss')
      }
      return '-'
    },
    currentIPs () {
      if (this.instancesInfo[this.instanceID].settings) {
        const IPs = this.instancesInfo[this.instanceID].settings.api.whitelistIP || []
        const obj = {}
        for (const IP of IPs) {
          obj[IP] = IP
        }
        return obj
      }
      return {}
    },
    actualToken () {
      if (this.instancesInfo[this.instanceID].settings) {
        return this.instancesInfo[this.instanceID].settings.api.apiToken.jwt
      }
      return ''
    },
    ...mapState({
      instanceID: state => state.admin.instanceID,
      instancesInfo: state => state.auth.instancesInfo,
      uid: state => state.auth.uid,
      jwt: state => state.auth.jwt,
    }),
  },
  mounted () {
    this.creditBinding = firebaseDb.ref(`/apiStats/${this.instanceID}`)
    this.creditBinding.on('value', (snapshot) => {
      if (snapshot.val() !== null) {
        this.consumedCredits = snapshot.val().consumedCredits
      }
    })
  },
  beforeDestroy () {
    this.creditBinding.off()
  },
  methods: {
    toClipboard () {
      const el = document.createElement('textarea')
      el.value = this.$refs.tokenContainer.value.trim()
      el.setAttribute('readonly', '')
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      el.setSelectionRange(0, 99999)
      document.execCommand('copy')
      document.body.removeChild(el)
      this.copied = true
      if (this.copiedTimmer) clearTimeout(this.copiedTimmer)
      this.copiedTimmer = setTimeout(() => {
        this.copied = false
      }, 1000)
    },
    async makeRequest ({ url, data }) {
      this.saving = true
      this.success = null
      try {
        await axios({
          url,
          data,
          method: 'POST',
        })
        this.success = true
      } catch (err) {
        if (err.response) {
          console.info(err.response)
          // client received an error response (5xx, 4xx)
        } else if (err.request) {
          console.info(err.request)
          // client never received a response, or request never left
        } else {
          console.info(err)
          // anything else
        }
        // TODO: show modal with error and reset status
        this.success = false
      } finally {
        this.saving = false
      }
    },
    async generateToken () {
      if (this.saving) return
      await this.makeRequest({
        url: '/instances/settings/api/generateToken',
        data: {
          instanceID: this.instanceID,
          createdBy: this.uid,
          token: this.jwt,
        },
      })
    },
    async setIPs (IPs) {
      await this.makeRequest({
        url: '/instances/settings/api/setWhitelist',
        data: {
          instanceID: this.instanceID,
          changedBy: this.uid,
          token: this.jwt,
          IPs,
        },
      })
    },
    addIP (selectedIP) {
      const actualIPs = new Set(this.instancesInfo[this.instanceID].settings.api.whitelistIP || [])
      actualIPs.add(selectedIP)
      this.setIPs(Array.from(actualIPs))
    },
    removeIP (selectedIP) {
      this.setIPs([...this.instancesInfo[this.instanceID].settings.api.whitelistIP].filter(actual => actual !== selectedIP))
    },
  },
}
</script>
<style lang="scss" scoped>
.fade-enter-active, .fade-leave-active {
  transition: all .3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(10px)
}
</style>
